<template>
  <!--订单继续支付-->
  <div id="orderrepay">
    <h2 class="title">
      <router-link :to="{name: 'MyOrder'}" class="prev"></router-link>
      订单详情
    </h2>
    <!--订单价格明细-->
    <div class="detail">
      <h3>您的订单价格明细</h3>
      <h3 style="display: none">订单号：{{shopData.shop_number}}</h3>
      <a>"{{shopData.shop_name}}"</a>
      <!--商品价格-->
      <div class="price">
        <b>商品价格</b>
        <span>¥{{shopData.pay_amount}}</span>
      </div>
    </div>
    <!--微信-->
    <div class="wxpay" v-if="paymentData[0]">
      <label>
        <b>微信支付</b>
        <input type="radio" name="paytype"  :value="paymentData[0].pay_id" v-model="payType" checked>
        <span></span>
      </label>
    </div>
    <!--支付宝-->
    <div class="alipay" v-if="paymentData[1]">
      <label>
        <b>支付宝支付</b>
        <input type="radio" name="paytype" :value="paymentData[1].pay_id" v-model="payType">
        <span></span>
      </label>
    </div>
    <div class="bg"></div>
    <div class="fix-bar">
      <b>¥{{parseFloat(shopData.pay_amount).toFixed(2)}}</b>
            <a @click="gotoPay" class="payfor">马上结算</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OrderRepay',
  data () {
    return {
      shopId: this.$route.query.shop_id, // 商品ID
      paymentData: {},
      shopData: {},
      payType: 1,
      isWeixin: false, // 是否微信浏览器打开  1 是  0 不是
      shopNumber: 0 // 商品订单号
    }
  },
  methods: {
    // 获取支付方式
    getPayment () {
      let data = {
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_order_payment_method',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.paymentData = res.data.data
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    // 获取订单信息
    getShop () {
      let data = {
        shop_id: this.$route.query.shop_id
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_order_again_payment',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log('获取订单信息:')
          console.log(res)
          if (res.data.errcode === 200) {
            this.shopData = res.data.data
            if (res.data.data.shop_number) {
              this.isWeixin = res.data.data.isWeixin
              this.shopNumber = res.data.data.shop_number
              this.checkOrderStatus() // 因微信使用返回上一步 暂时解决方案
            }
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    gotoPay () {
      this.$router.push({
        name: 'OrderRepaying',
        params: {
          shop_id: this.$route.query.shop_id,
          payment_method: this.payType,
          _sign: this.submitSign
        },
        query: {
          shop_number: this.shopNumber
        }
      })
      return false
    }
  },
  computed: {
    submitSign: function () {
      let data = {
        shop_id: this.$route.query.shop_id,
        payment_method: this.payType
      }
      return this.$encryption(data, this.$store.state.token, this.$store.state.uid)
    }
  },
  mounted () {
    this.getPayment()
    this.getShop()
  }
}
</script>

<style scoped lang="stylus">
#orderrepay
  background-color: #F7F7F7
  .title
    position: relative
    line-height: .8rem
    background-color: #1E81F2
    padding: .14rem .16rem
    font-size: .4rem
    color: #fff
    font-weight: 600
    text-align: center
    a.prev
      position: absolute
      top: .14rem
      left: .16rem
      display: block
      width: .8rem
      height: .8rem
      background-color: transparent
      -webkit-border-radius: 50%
      -moz-border-radius: 50%
      border-radius: 50%
      &::before
        content: ""
        position: absolute
        top: .3rem
        left: .32rem
        display: block
        width: .20rem
        height: .20rem
        border-left: .03rem solid #fff
        border-bottom: .03rem solid #fff
        -webkit-transform: rotate(45deg)
        -moz-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        -o-transform: rotate(45deg)
        transform: rotate(45deg)
  .address
    display: flex
    justify-content: space-between
    align-items: center
    width: 7.5rem
    height: 2.24rem
    padding: 0 .4rem
    background-color: #fff
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    p
      width: 6.14rem
      font-size: .26rem
      color: #333
      b.where
        font-size: .4rem
        color: #050505
        font-weight: 700
      &.selected
        padding-left: .76rem
        font-size: .26rem
        color: #333
        /*background: url(../../assets/icon/orderconfirm_icon_locate.png) no-repeat left .65rem*/
        background: url(../../assets/icon/orderconfirm_icon_locate.png) no-repeat left center
        -webkit-background-size: .56rem
        background-size: .56rem
        -webkit-box-sizing: border-box
        -moz-box-sizing: border-box
        box-sizing: border-box
        b
          display: inline-block
          margin: 0 .2rem .1rem 0
          font-size: .36rem
          color: #050505
        i
          font-size: .24rem
          color: #9DA4B3
          font-style: normal
    span.arrow
      position: relative
      top: .03rem
      right: .2rem
      display: block
      width: .20rem
      height: .20rem
      border-left: .03rem solid #050505
      border-bottom: .03rem solid #050505
      -webkit-transform: rotate(-135deg)
      -moz-transform: rotate(-135deg)
      -ms-transform: rotate(-135deg)
      -o-transform: rotate(-135deg)
      transform: rotate(-135deg)
  .detail
    width: 7.5rem
    height: 2.92rem
    background-color: #fff
    padding: .4rem
    margin-top: .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    h3
      margin: .2rem auto
      font-size: .4rem
      color: #333
      text-align: left
    a
      margin: .36rem 0
      font-size: .36rem
      color: #1E81F2
    .price
      display: flex
      justify-content: space-between
      align-items: center
      height: .44rem
      line-height: .44rem
      margin: .26rem 0
      b
        font-size: .32rem
        color: #3D3C45
        font-weight: 400
      span
        font-size: .32rem
        color: #A3A9B7
  .coupon
    display: flex
    justify-content: space-between
    align-items: center
    height: .8rem
    line-height: .8rem
    background-color: #fff
    padding: 0 .4rem
    margin-top: .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    b
      font-size: .24rem
      color: #333
      font-weight: 400
    a
      font-size: .24rem
      color: #333
      font-weight: 400
      span.dot
        position: relative
        top: -.04rem
        display: inline-flex
        justify-content: space-between
        align-items: center
        width: .3rem
        height: .09rem
        vertical-align: baseline
        margin: 0 .1rem
        i
          display: inline-block
          width: .09rem
          height: .09rem
          background-color: #999
          -webkit-border-radius: 50%
          -moz-border-radius: 50%
          border-radius: 50%
          &:nth-of-type(1), &:nth-of-type(3)
            display: inline-block
            width: .06rem
            height: .06rem
            background-color: #D8D8D8
            -webkit-border-radius: 50%
            -moz-border-radius: 50%
            border-radius: 50%
  .wxpay, .alipay
    width: 7.5rem
    height: .8rem
    background-color: #fff
    padding: 0 .4rem
    margin-top: .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    label
      display: flex
      justify-content: space-between
      align-items: center
      height: 100%
      b
        font-size: .24rem
        color: #333
        &::before
          content: ""
          display: inline-block
          width: .4rem
          height: .4rem
          background: url(../../assets/icon/orderdetail_icon_weixin.png) no-repeat center
          -webkit-background-size: 100%
          background-size: 100%
          vertical-align: middle
          margin-right: .2rem
      input
        display: none
      span
        display: inline-block
        width: .4rem
        height: .4rem
        background: url(../../assets/icon/classall_icon_noselect.png) no-repeat center
        -webkit-background-size: 100%
        background-size: 100%
      input:checked + span
        background-image: url(../../assets/icon/classall_icon_tick.png)
  .alipay
    label
      b
        &::before
          background-image: url(../../assets/icon/orderdetail_icon_zhifubao.png)
  .bg
    position: fixed
    top: 0
    left: 0
    z-index: -1
    width: 100%
    height: 100%
    background-color: #F7F7F7
  .fix-bar
    position: fixed
    bottom: 0
    left: 0
    display: flex
    justify-content: space-between
    align-items: center
    width: 7.5rem
    height: .98rem
    background-color: #fff
    padding: 0 .2rem
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    b
      display: block
      width: 2rem
      height: .98rem
      line-height: .98rem
      font-size: .28rem
      color: #FF7052
      text-align: center
    .discount
      /*visibility: hidden*/
      width: 2.68rem
      height: .98rem
      line-height: .98rem
      margin-right: .2rem
      background-color: rgba(172,229,255,.12)
      font-size: .24rem
      color: #2BAAFF
      text-align: center
    a.payfor
      display: inline-block
      width: 2.4rem
      height: .72rem
      line-height: .72rem
      background-color: #FF7052
      /* background-color: rgba(255,112,82,0.7) */
      font-size: .32rem
      color: #fff
      text-align: center
      -webkit-border-radius: .49rem
      -moz-border-radius: .49rem
      border-radius: .49rem
</style>



// WEBPACK FOOTER //
// src/components/order/OrderRepay.vue